module.exports = "<vb-main-navigation></vb-main-navigation>\r\n\r\n<vb-loading></vb-loading>\r\n\r\n\r\n<router-outlet></router-outlet>\r\n\r\n<hr>\r\n\r\n<footer class=\"row\">\r\n  <p class=\"text-center\">&copy; {{today | date:'yyyy'}} witcotech UG</p>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visbos-client/visbos-client.component.html
// module id = ./src/app/visbos-client/visbos-client.component.html
// module chunks = main